import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dwoDateTime',
  standalone: false,
})
export class DwoDateTimePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor() {
    this.datePipe = new DatePipe('en');
  }

  transform(value: any): string {
    const dateTime = this.datePipe.transform(value, 'dd-MMM-yyyy, HH:mm');
    return dateTime ? dateTime.toUpperCase() : '';
  }
}
